import { AutoBreaksCalculationService } from './types';

import { AutoBreaksCalculationServiceSimple } from './autoBreaksCalculationServiceSimple';

export { calculateTimeEntryStats } from './helpers';
export * from './types';

export const autoBreaksCalculationService: AutoBreaksCalculationService =
  new AutoBreaksCalculationServiceSimple();
